module.exports = __webpack_public_path__ + "img/main-logo.ebf0dacb.png";